// Use CRUD naming to align with RESTful API (as opposed to GraphQL or RPC)
import { type MenuId } from '../../../models';

interface ReadKpisResponse {
  configData: string;
}

const baseUrl = process.env.REACT_APP_NAV_API ?? '';

export async function readKpis(gatewayApiUrl: string): Promise<MenuId[]> {
  const response = await fetch(
    `${baseUrl}${gatewayApiUrl}/api/idw/config/HOMEPAGE_KPIS`
  );
  const data = (await response.json()) as ReadKpisResponse;

  if (data.configData === '') {
    return [];
  }

  const obj = JSON.parse(data.configData) as object;

  return Object.keys(obj);
}

export async function readKpi(
  requestUrl: string,
  requestMethod: string,
  requestBody: object | undefined,
  augmentHeaders: ((headers: HeadersInit) => HeadersInit) | undefined = (h) => h
): Promise<object> {
  const headers: HeadersInit = requestBody
    ? { 'Content-Type': 'application/json' }
    : {};

  const response = await fetch(baseUrl + requestUrl, {
    method: requestMethod,
    body: JSON.stringify(requestBody),
    headers: augmentHeaders(headers),
  });

  return response.json() as object;
}
